import { useState, useEffect } from 'react';

export default function CfgFijo({ producto, onUpdate, precio, desc }) {
  const [p, setP] = useState(producto.precioFinal || precio);

  useEffect(() => {
    if (!producto.configurado) onUpdate({ config: {}, precioFinal: precio });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-4 bg-brand-gold/5 border border-brand-gold/20 rounded-lg">
      <div className="text-xs text-neutral-400 mb-3">{desc}</div>
      <div className="flex items-center gap-2">
        <span className="text-xs text-neutral-500 uppercase tracking-wider">Precio</span>
        <input
          type="number"
          value={p}
          onChange={(e) => {
            const val = parseFloat(e.target.value) || 0;
            setP(val);
            onUpdate({ config: {}, precioFinal: val });
          }}
          className="flex-1 px-3 py-2 bg-neutral-900 border border-neutral-800 rounded text-sm text-white text-right font-medium focus:outline-none focus:border-brand-gold/50"
        />
      </div>
    </div>
  );
}
